export default __webpack_public_path__ + "static/media/table_action _icon.b5ea6652.svg";